import * as React from "react";
import { Id } from "@repo/convex/convex/_generated/dataModel";
import { Dialog, Flex } from "@radix-ui/themes";
import { useQuery } from "convex-helpers/react/cache/hooks";
import { api } from "@repo/convex/convex/_generated/api";
import { ConnectedNotesEditor, SaveState } from "./ConnectedNotesEditor.tsx";
import { SaveStateLabel } from "./SaveStateLabel.tsx";
import { DialogCloseButton } from "../../common/DialogCloseButton.tsx";
import { itemTitle } from "../../common/items/format.ts";

interface Props {
  itemId: Id<"items"> | null;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => unknown;
}

export const NotesEditorDialog: React.FC<Props> = ({ itemId, setIsOpen, isOpen }) => {
  const [saveState, setSaveState] = React.useState<SaveState>({ kind: "loading" });
  const item = useQuery(api.items.findMine, itemId ? { itemId } : "skip");

  return (
    <Dialog.Root
      open={isOpen}
      onOpenChange={(isOpen) => {
        if (!itemId) return;
        setIsOpen(isOpen);
      }}
    >
      <Dialog.Content align={"start"} maxWidth="640px" style={{ marginTop: "6vh" }}>
        <Dialog.Title mb={"1"}>Notes</Dialog.Title>
        <Dialog.Description color={"gray"} size={"2"} mb={"4"}>
          {item ? itemTitle(item) : "\u00a0"}
        </Dialog.Description>
        <DialogCloseButton onClick={() => setIsOpen(false)} />

        {isOpen ? <ConnectedNotesEditor itemId={itemId} onSaveStateChange={setSaveState} /> : null}

        <Flex gap="3" mt="3" justify="between" align="center">
          <span className="notes-hint">Searchable, so the AI can help you find it later.</span>
          <SaveStateLabel state={saveState} />
        </Flex>
      </Dialog.Content>
    </Dialog.Root>
  );
};
